module.exports = __webpack_public_path__ + "static/media/remirus.ec09d763.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/remirus.jpg
// module id = 276
// module chunks = 1